import { render, staticRenderFns } from "./ProductContent.vue?vue&type=template&id=1418db60&scoped=true&"
import script from "./ProductContent.vue?vue&type=script&lang=js&"
export * from "./ProductContent.vue?vue&type=script&lang=js&"
import style0 from "./ProductContent.vue?vue&type=style&index=0&id=1418db60&prod&scoped=true&lang=css&"
import style1 from "./ProductContent.vue?vue&type=style&index=1&id=1418db60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1418db60",
  null
  
)

export default component.exports